import { RequestOptions } from './request-options';

export class AlternativeCompundsRequest extends RequestOptions  {
    Id_Plan: number;
    Id_Stage: number;
    ChangesOnly: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/alternative-compunds-request.ts